// Workspace slug rules shared by frontend (live availability UX) and
// backend (validation + collision check). Both depend on this exact
// logic; keeping it in one place prevents drift.
//
// Any new top-level path component on app.parable.so should be added to
// RESERVED_SLUGS before it ships, or workspaces could shadow the route.

export const RESERVED_SLUGS = new Set<string>([
  "login",
  "signup",
  "signin",
  "oauth",
  "auth",
  "invite",
  "invites",
  "onboarding",
  "settings",
  "api",
  "app",
  "admin",
  "help",
  "docs",
  "pricing",
  "about",
  "home",
  "www",
  "static",
  "_next",
  "assets",
  "public",
  "health",
  "status",
  "workspaces",
]);

// Convert a free-form name into a candidate slug. Stripped ASCII only,
// kebab-cased, deduped dashes, trimmed. Output may still fail isSlugValid
// (too short, reserved word, starts with digit) — callers should validate
// the result before persisting.
export function slugify(name: string): string {
  const ascii = name.normalize("NFKD").replace(/[̀-ͯ]/g, "");
  return ascii
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Validate a workspace slug for persistence + URL safety.
// - 3-32 chars
// - Lowercase letters, digits, dashes only
// - Must start with a letter (avoids ambiguity with numeric ids in URLs)
// - Not in RESERVED_SLUGS (would shadow frontend routes)
export function isSlugValid(slug: string): boolean {
  if (typeof slug !== "string") return false;
  if (slug.length < 3 || slug.length > 32) return false;
  if (!/^[a-z][a-z0-9-]*$/.test(slug)) return false;
  if (slug.endsWith("-")) return false;
  if (slug.includes("--")) return false;
  if (RESERVED_SLUGS.has(slug)) return false;
  return true;
}
